import React from 'react';
import b1 from "../../../images/blog/blog_1.png"
import b2 from "../../../images/blog/blog_2.png"
import b3 from "../../../images/blog/blog_3.png"
import b4 from "../../../images/blog/blog_4.png"

import "./blog2.css"
const Blog2 = () => {
  return (
    <section className="blog_part section_padding mt-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="section_tittle text-center">
              
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <div className="single-home-blog">
              <div className="card">
                <img src={b1} className="card-img-top" alt="blog" />
                <div className="card-body">
                  <a href="blog.html">
                    <p className="card-title">Prioritize mental health with stress management and self-care. Emotional well-being is integral to overall health. </p>
                  </a>
                  <ul>
                    <li> <span className="ti-user"></span>Dr. Samye </li>
                    <li> <span className="ti-bookmark"></span>Clinic, doctors</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="single-home-blog">
              <div className="card">
                <img src={b3} className="card-img-top" alt="blog" />
                <div className="card-body">
                  <a href="blog.html">
                    <p className="card-title">Ensure access to quality healthcare services, promoting prompt treatment and a healthier community.  </p>
                  </a>
                  <ul>
                    <li> <span className="ti-user"></span>Dr. Nick Rudel</li>
                    <li> <span className="ti-bookmark"></span>Clinic, doctors</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="single-home-blog">
              <div className="card">
                <img src={b1} className="card-img-top" alt="blog" />
                <div className="card-body">
                  <a href="blog.html">
                    <p className="card-title">Adopt a balanced diet and exercise routine to maintain physical health, reducing the risk of chronic diseases.</p>
                  </a>
                  <ul>
                    <li> <span className="ti-user"></span>Dr. Jameson</li>
                    <li> <span className="ti-bookmark"></span>Clinic, doctors</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="single-home-blog">
              <div className="card">
                <img src={b2} className="card-img-top" alt="blog" />
                <div className="card-body">
                  <a href="blog.html">
                    <p className="card-title">Regular check-ups and vaccinations are crucial for preventing illnesses. Early detection can lead to more effective treatments.</p>
                  </a>
                  <ul>
                    <li> <span className="ti-user"></span>Dr. Lilion Mike mike</li>
                    <li> <span className="ti-bookmark"></span>Clinic, doctors</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog2;
